import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import NotIframeCatch from "./components/NotIframeCatch/NotIframeCatch";
import Trigger from "./components/Trigger/Trigger";
import { Challenge } from "./components/Challenge/Challenge";
const isInIframe = (): boolean => {
  if (window.location !== window.parent.location) {
    return true;
  } else {
    return false;
  }
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={isInIframe() ? <Trigger /> : <NotIframeCatch />}
        />
        <Route
          path="/challenge"
          element={isInIframe() ? <Challenge /> : <NotIframeCatch />}
        />
        <Route
          path="/reattempt"
          element={
            isInIframe() ? <Challenge reattempt={true} /> : <NotIframeCatch />
          }
        />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
